import { render, staticRenderFns } from "./preview_add.vue?vue&type=template&id=3816bb39&scoped=true&"
import script from "./preview_add.vue?vue&type=script&lang=js&"
export * from "./preview_add.vue?vue&type=script&lang=js&"
import style0 from "./preview_add.vue?vue&type=style&index=0&id=3816bb39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3816bb39",
  null
  
)

export default component.exports